var e4 = e4 || {},
    identity = identity || {};

//identity.activeCampaign.xhr('POST', '/contacts', {type: 'contact', email: 'lhn@co3.dk'})
// returns userID
//identity.activeCampaign.xhr('POST', '/contactLists', {type: 'contactList', list: 8, contact: userID, status: 1})
identity.activeCampaign = {
  init: function() {
    identity.activeCampaign.subscribeFromFooter();
    identity.activeCampaign.bindEvents();
  },
  bindEvents: function() {
    jQuery( '.js-active-campaign-receipt-modal-accept' ).on( 'click', function() {
      var data = window.activeCampaignSubscriptionData;
      console.log( ['Trigger AC Modal Submit'].join( ' ' ) );
      identity.activeCampaign.subscribeFromCheckout( data );
    } );
  },
  xhr: function( strMethod, strPath, objFields ) {
    var objData = {
      path: strPath,
      method: strMethod,
    };
    if ( objFields !== undefined ) {
      objData = jQuery.extend( objData, objFields );
    }
    return jQuery.ajax( {
      url: e4.settings.activeCampaign.url,
      method: 'POST',
      dataType: 'json',
      data: objData,
    } );
  },
  getData: ( path ) => {
    identity.activeCampaign.xhr( 'GET', path );
  },
  getContact: async ( email ) => {
    return identity.activeCampaign.xhr( 'GET', `/contacts?email=${ email }` );
  },
  errorHandling: function( jsonResponse, domForm ) {
    if ( jsonResponse.error ) {
      if ( domForm !== undefined ) {
        var jFormErrorMsg = jQuery( domForm ).find( '.js-active-campaign-error-msg' );
        if ( jFormErrorMsg.length ) {
          jFormErrorMsg.removeClass( 'd-none' );
          setTimeout( function() {
            jFormErrorMsg.fadeOut( 500, function() {
              jFormErrorMsg.addClass( 'd-none' );
            } );
          }, 2000 );
        }
      } else {
        jQuery( '.js-active-campaign-receipt-modal' ).modal( 'hide' );
      }
      return false;
    }
    return true;
  },
  getFormElementValue: function( arrFormData, inputName ) {
    return arrFormData.filter( function( input ) {
      return input.name === inputName;
    } )[0].value;
  },
  contactCreatedCallback: function( jsonResponse, objData, domForm, contactTags ) {
    //Callback for created contact => subscribe to list
    console.group( 'Contact Created Callback' );
    var contactId = jsonResponse.contact.id,
        contactTagsTypes = contactTags.split( ',' ),
        deferredXhr = [],
        xhrAddNewContactToList = identity.activeCampaign.xhr( 'POST', '/contactLists', {
          type: 'contactList',
          list: parseInt( objData.listId ),
          contact: contactId,
          status: 1
        } ),
        xhrAddTagToNewContact = null,
        xhrAddBoughtTagToNewContact = null,
        xhrAddInterestTag = null;
    deferredXhr.push( xhrAddNewContactToList );
    console.log( ['Adding Contact', contactId, 'to list', objData.listId].join( ' ' ) );

    if ( contactTagsTypes.indexOf( 'contactTag' ) > -1 ) {
      xhrAddTagToNewContact = identity.activeCampaign.xhr( 'POST', '/contactTags', {
        type: 'contactTag',
        contact: contactId,
      } );
      deferredXhr.push( xhrAddTagToNewContact );
      console.log( ['Adding contactTag', 'B2C', 'to contact', contactId].join( ' ' ) );
    }
    if ( contactTagsTypes.indexOf( 'boughtTag' ) > -1 ) {
      xhrAddBoughtTagToNewContact = identity.activeCampaign.xhr( 'POST', '/contactTags', {
        type: 'boughtTag',
        contact: contactId,
      } );
      deferredXhr.push( xhrAddBoughtTagToNewContact );
      console.log( ['Adding contactTag', 'Købt', 'to contact', contactId].join( ' ' ) );
    }
    if ( contactTagsTypes.indexOf( 'interestMailTag' ) > -1 ) {
      xhrAddInterestTag = identity.activeCampaign.xhr( 'POST', '/contactTags', {
        type: 'interestMailTag',
        contact: contactId,
      } );
      deferredXhr.push( xhrAddInterestTag );
      console.log( ['Adding contactTag', 'Interest', 'to contact', contactId].join( ' ' ) );
    }
    if ( contactTagsTypes.indexOf( 'interestDealTag' ) > -1 ) {
      xhrAddInterestTag = identity.activeCampaign.xhr( 'POST', '/contactTags', {
        type: 'interestDealTag',
        contact: contactId,
      } );
      deferredXhr.push( xhrAddInterestTag );
      console.log( ['Adding contactTag', 'Interest', 'to contact', contactId].join( ' ' ) );
    }

    if ( objData?.source ) {
      xhrUpdateSource = identity.activeCampaign.xhr( 'PUT', `/contacts/${contactId}`, {
        type: 'updateContact',
        source: objData.source,
      } );
      deferredXhr.push( xhrUpdateSource );
    }
    
    if ( domForm !== undefined ) {
      if ( jQuery( '.js-e-checkout-receipt ' ).length === 1 && objData.activeCampaignSubscription === 'no' ) {
        jQuery( '.js-e-page-loading-overlay' ).addClass( 'is-loading' );
        console.log( ['Loading'].join( ' ' ) );
      }

      console.groupEnd();

      jQuery.when.apply( jQuery, deferredXhr ).done( function() {
        console.log( ['Deferred xhr resolved', 'Getting callback'].join( ' ' ) );
        if ( domForm !== undefined ) {
          console.log( ['Has domForm', 'Submitting'].join( ' ' ) );
          var jActiveCampaignForm = jQuery( domForm );
          if ( jActiveCampaignForm.length && jQuery( '.js-e-checkout-receipt' ).length === 0 ) {
            identity.activeCampaign.processingForm = false;
            jActiveCampaignForm.submit();
          }
        } else {
          console.log( ['Remove loading', 'Hide modal'].join( ' ' ) );
          jQuery( '.js-e-page-loading-overlay' ).removeClass( 'is-loading' );
          jQuery( '.js-active-campaign-receipt-modal' ).modal( 'hide' );
        }
      } );

      jQuery( '.js-active-campaign-receipt-modal' ).modal( 'hide' );
    }
  },
  subscribeFromCheckout: function( objSubscriptionData ) {
    var objData = {
      type: 'contact',
      email: objSubscriptionData.email,
      firstName: objSubscriptionData.firstName,
      lastName: objSubscriptionData.lastName,
      phone: objSubscriptionData.phone,
      listId: objSubscriptionData.listId,
    };
    identity.activeCampaign.xhr( 'POST', '/contacts', objData ).done( function( jsonResponse ) {
      if ( identity.activeCampaign.errorHandling( jsonResponse ) === true ) {
        var contactTags = objSubscriptionData.activeCampaignSubscription === 'yes' ? 'contactTag,boughtTag' : 'boughtTag';
        identity.activeCampaign.contactCreatedCallback( jsonResponse, objData, undefined, contactTags );
      }
    } );
  },
  designerCartSendMail: async ( objSubscriptionData ) => {
    const listId = 7;
    const sourceValue = 'ID Designer';

    const objData = {
      type: 'contactSendDesignerMail',
      email: objSubscriptionData.email,
      firstName: objSubscriptionData.firstName,
      lastName: objSubscriptionData.lastName,
      listId: listId,
      source: sourceValue,
    };

    const contactResponse = await identity.activeCampaign.getContact( objSubscriptionData.email );

    if ( contactResponse.contacts.length > 0 ) {
      const contactTags = 'interestMailTag';
      const contact = contactResponse.contacts[0];
      identity.activeCampaign.contactCreatedCallback( { contact }, objData, undefined, contactTags );
    } else {
      identity.activeCampaign.xhr( 'POST', '/contacts', objData ).done( function( jsonResponse ) {
        if ( identity.activeCampaign.errorHandling( jsonResponse ) === true ) {
          const contactTags = 'interestMailTag';
          identity.activeCampaign.contactCreatedCallback( jsonResponse, objData, undefined, contactTags );
        }
      } );
    }
  },
  subscribeFromDesignerCheckout: async ( objSubscriptionData ) => {
    const listId = 7;
    const sourceValue = 'ID Designer';

    const contactResponse = await identity.activeCampaign.getContact( objSubscriptionData.email );

    const objData = {
      type: 'contactDesignerCheckout',
      email: objSubscriptionData.email,
      company: objSubscriptionData.company,
      firstName: objSubscriptionData.firstName,
      lastName: objSubscriptionData.lastName,
      country: objSubscriptionData.country,
      phone: objSubscriptionData.phone,
      listId: listId,
      source: sourceValue,
    };
    if ( contactResponse.contacts.length > 0 ) {
      const contactTags = 'interestDealTag';
      const contact = contactResponse.contacts[0];
      identity.activeCampaign.contactCreatedCallback( { contact }, objData, undefined, contactTags );
    } else {
      identity.activeCampaign.xhr( 'POST', '/contacts', objData ).done( function( jsonResponse ) {
        if ( identity.activeCampaign.errorHandling( jsonResponse ) === true ) {
          const contactTags = 'interestDealTag';
          identity.activeCampaign.contactCreatedCallback( jsonResponse, objData, undefined, contactTags );
        }
      } );
    }

  },
  subscribeFromFooter: function() {
    identity.activeCampaign.processingForm = true;
    var collapseContentElement = jQuery( '.js-footer-form-collapse-content' ),
        jParent = collapseContentElement.closest( 'label' );
    if ( collapseContentElement.length > 0 ) {
      var jCollapse = jParent.find( '.collapse' ),
          intInitialHeight = jCollapse.height();
      jCollapse.height( intInitialHeight );
      jCollapse.on( 'show.bs.collapse', function() {
        jParent.find( '.js-footer-form-collapse-content-toggle' ).hide();
      } ).on( 'hide.bs.collapse', function() {
        jParent.find( '.js-footer-form-collapse-content-toggle' ).show();
      } ).on( 'hidden.bs.collapse', function() {
        jCollapse.height( intInitialHeight );
      } );
    }
    jQuery( '.js-active-campaign-signup-form' ).validate( {
      submitHandler: function( domForm ) {
        var jForm = jQuery( domForm );
        if ( identity.activeCampaign.processingForm === false ) {
          location.href = jForm.data( 'redirect' );
        } else {
          var arrFormData = jForm.serializeArray();
          if ( jForm.valid() ) {
            var objData = {
              type: 'contact',
              email: identity.activeCampaign.getFormElementValue( arrFormData, 'ActiveCampaignEmail' ),
              firstName: identity.activeCampaign.getFormElementValue( arrFormData, 'ActiveCampaignName' ),
              lastName: '',
              phone: '',
              listId: identity.activeCampaign.getFormElementValue( arrFormData, 'ActiveCampaignListId' ),
            };
            identity.activeCampaign.xhr( 'POST', '/contacts', objData ).done( function( jsonResponse ) {
              if ( identity.activeCampaign.errorHandling( jsonResponse, domForm ) === true ) {
                identity.activeCampaign.contactCreatedCallback( jsonResponse, objData, domForm, 'contactTag' );
              }
            } );
          }
        }
      },
    } );
  },
};